import React, { useEffect, useState } from "react";

const isTapContext = () =>
  window.matchMedia("(max-width: 767.98px)").matches ||
  window.matchMedia("(display-mode: standalone)").matches ||
  window.navigator.standalone === true;

const NotificationClickHint = () => {
  const [useTap, setUseTap] = useState(isTapContext);

  useEffect(() => {
    const update = () => setUseTap(isTapContext());
    const mobileQuery = window.matchMedia("(max-width: 767.98px)");
    const standaloneQuery = window.matchMedia("(display-mode: standalone)");

    mobileQuery.addEventListener("change", update);
    standaloneQuery.addEventListener("change", update);
    window.addEventListener("resize", update);

    return () => {
      mobileQuery.removeEventListener("change", update);
      standaloneQuery.removeEventListener("change", update);
      window.removeEventListener("resize", update);
    };
  }, []);

  return (
    <p className="notification-click-hint text-muted mb-0 mt-1">
      {useTap
        ? "💡 Tap any notification to open the related page."
        : "💡 Click any notification to open the related page."}
    </p>
  );
};

export default NotificationClickHint;
